import { state } from "../state.js";
import { stringToCells, alignCells, cellsToString } from "../cell.js";
import { printLine, parseStyledString } from "../utilities.js";
import { programs } from "../programs.js";

export const list = async () => {
    if (state.loadedProgram !== null) {
        await listProgram();
    } else if (state.loadedDirectory !== null) {
        await listDirectory();
    } else {
        await printLine();
    }
};

const listDirectory = async () => {
    await printLine();
    await printLine(parseStyledString("0 [bg=default_fg,fg=default_bg]\"DSS SOLUTIONS  \" 00 2A[/]"));

    // Loop through all programs and print their names.
    for (const program of programs) {
        const spaces = " ".repeat(5 - program.size.toString().length);
        let line = program.size + spaces + "\"" + program.name.toUpperCase() + "\"";
        const cells = stringToCells(line);
        const paddedCells = alignCells(cells, 23, 'left');
        line = cellsToString(paddedCells);
        await printLine(line + "PRG");
    }

    // Calculate the 'blocks free'. This should be 664 minus the size of all programs.
    const totalSize = programs.reduce((acc, program) => acc + program.size, 0);
    const blocksFree = 664 - totalSize;
    await printLine(blocksFree + " BLOCKS FREE.");
};

const listProgram = async () => {
    await printLine();

    const program = state.loadedProgram;
    if (program === null || program === undefined) {
        return;
    }
    
    await program.list();
};